import { useLanguage } from "@/context/LanguageContext";
import { NAV } from "@/constants/testIds";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export default function LanguageSwitcher({ compact = false, prominent = false, onChange, testId = NAV.languageSelector }) {
  const { lang, setLang, languages, label, flag } = useLanguage();

  const handle = (code) => {
    setLang(code);
    if (onChange) onChange(code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testId}
          translate="no"
          className={prominent
            ? "inline-flex items-center gap-1.5 h-9 px-3 rounded-full text-sm font-semibold text-slate-800 bg-white border border-slate-300 shadow-sm active:bg-slate-100 transition-colors"
            : "inline-flex items-center gap-1.5 h-9 px-3 rounded-md text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors border border-transparent hover:border-slate-200"}
          aria-label="Change language"
        >
          {!prominent && <Globe size={14} />}
          {prominent && <span className="text-base leading-none">{flag}</span>}
          <span className="font-medium">{compact ? lang.toUpperCase() : label}</span>
          {!prominent && <span className="text-base leading-none">{flag}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44" translate="no">
        {languages.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`${NAV.languageOption}-${l.code}`}
            onClick={() => handle(l.code)}
            translate="no"
            className="cursor-pointer flex items-center justify-between"
          >
            <span className="flex items-center gap-2" translate="no">
              <span>{l.flag}</span>
              <span>{l.label}</span>
            </span>
            {lang === l.code && <Check size={14} className="text-blue-800" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
